import { Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { Pattern1 } from '../assets/icons/pattern';
import { Absolute } from './primitives/absolute';

export const DecorativeHeading = (props: { text: string }) => {
  const { text } = props;
  const theme = useTheme();
  //   return (
  //     <Box
  //       sx={{
  //         width: '60%',
  //         marginX: 'auto',
  //         [theme.breakpoints.down('md')]: {
  //           width: '100%'
  //         }
  //       }}
  //     >
  //       <Box paddingRight="7.5%" textAlign="right" width="100%">
  //         <Pattern1 color={'secondary'} width="5.5%" height="auto" />
  //       </Box>
  //       <Typography
  //         color="primary.main"
  //         fontFamily="Tropiline"
  //         textAlign="center"
  //         variant="h2"
  //         py="10px"
  //         position="relative"
  //       >
  //         {text}
  //       </Typography>
  //       <Box paddingLeft="10%" textAlign="left" width="100%">
  //         <Pattern1 color={'secondary'} width="5.5%" height="auto" />
  //       </Box>
  //     </Box>
  //   );

  //   Don't remove this might be useful
  return (
    <Box>
      <Typography
        color="primary.main"
        fontFamily="Tropiline"
        textAlign="center"
        variant="h2"
        py="10px"
        px="20px"
      >
        <div
          style={{
            maxWidth: '600px',
            position: 'relative',
            display: 'inline-block',
            fontFamily: 'inherit'
          }}
        >
          <Absolute right={{ xs: '-5%', sm: '-10%' }} textAlign="right" width="100%" top="-50px">
            <Pattern1 color={'secondary'} width="10%" height="auto" />
          </Absolute>
          {text}
          <Absolute left={{ xs: '-5%', sm: '-12.5%' }} textAlign="left" width="100%" bottom="-50px">
            <Pattern1 color={'secondary'} width="10%" height="auto" />
          </Absolute>
        </div>
      </Typography>
    </Box>
  );
};
